const Breakpoints = {
  desktop5: 1440,
  desktop4: 1276,
  desktop3: 1200,
  desktop2: 1072,
  desktop: 1024,
  tablet: 768,
  tablet2: 900,
  mobile: 400,
  mobile2: 600,
  mobile3: 500,
  mobile4: 360,
  mobile5: 385,
};

export default Breakpoints;
